import { FeatureCollection, MultiLineString } from 'geojson'
import { useMemo } from 'react'
import { Layer, Source, SymbolLayer } from 'react-map-gl'
import { IRoute } from 'utils/interfaces'

const textLayer: SymbolLayer = {
  id: 'recorded-route-text-layer',
  type: 'symbol',
  layout: {
    'text-field': ['get', 'name'],
    'text-font': ['Open Sans Regular'],
    'text-offset': [0, 0],
    'text-anchor': 'center',
    'symbol-placement': 'point',
  },
  paint: {
    'text-halo-color': 'white',
    'text-halo-width': 2,
    'text-halo-blur': 1,
  },
}

const CleaningRoutesNamesOnMap = ({ cleaningRoutes }: { cleaningRoutes: IRoute[] }) => {
  const cleaningRoutesFeatureCollections: FeatureCollection<MultiLineString> = useMemo(() => {
    return {
      type: 'FeatureCollection',
      features: cleaningRoutes,
    }
  }, [cleaningRoutes])

  return (
    <Source id="cleaning-routes-names" type="geojson" data={cleaningRoutesFeatureCollections}>
      <Layer {...textLayer} />
    </Source>
  )
}

export default CleaningRoutesNamesOnMap
